import React from "react";
import { useMsal } from "@azure/msal-react";
import { ActionButton } from "../styles/Buttons";
import SignOutIcon from "./icons/SignOutIcon";

export const SignOutButton = () => {
  const { instance } = useMsal();

  const handleLogout = () => {
    instance.logoutRedirect({
      postLogoutRedirectUri: "/",
    });
  };

  return (
    <ActionButton 
      data-scale='true'
      onClick={() => handleLogout()}
    >
      <SignOutIcon />
      <span>Logga ut</span>
    </ActionButton>
  );
};